<div class="html-page-form" *ngIf="initialized">

  <div class="full-form">

    <mat-form-field class="input-full-width">
      <input type="number" name = "sessionTimeout" matInput placeholder="{{'SessionConfig.seconds.placeholder' | translate}}" [(ngModel)]="sessionConfig.sessionTimeout" required>
      <mat-icon matSuffix>av_timer</mat-icon>
    </mat-form-field>

  </div>

  <div class="buttons">
    <button class="left-margin login-button" mat-flat-button color="primary" [disabled]="!isFilled()"
            (click)="save()" type="submit" prevent-double-submit [@inProgress]="inProgress">
      <mat-icon color="accent" class="login-icon">done</mat-icon>
      <app-progress-button
        [progress]="inProgress"
        [success]="success"
        [standardButtonLabel]="'SessionConfig.saveButton'"
        [successButtonLabel]="'SessionConfig.saveButton.success'"></app-progress-button>
    </button>
  </div>


</div>
